import { FC, useState } from 'react'

import DataObjectIcon from '@mui/icons-material/DataObject'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useAuthStore } from '@/stores/useAuthStore'

import { ConsoleDialog } from '../ConsoleDialog'
import { CopyContent } from '../CopyContent'

export const WSAuthToken: FC = () => {
  const [open, setOpen] = useState(false)
  const token = useAuthStore((state) => state.token) || ''
  const truncatedToken = JSON.stringify({ authToken: token.split('.')[0] + '...' }, null, 2)

  return (
    <>
      <MenuItem onClick={() => setOpen(true)} divider>
        <ListItemIcon>
          <DataObjectIcon />
        </ListItemIcon>
        <ListItemText>WS Token</ListItemText>
      </MenuItem>

      {open && (
        <ConsoleDialog open title="WebSocket Auth Token" onClose={() => setOpen(false)}>
          <CopyContent value={token} mono label="Token" displayValue={truncatedToken} />
        </ConsoleDialog>
      )}
    </>
  )
}
